import {createContext} from 'react';

export const JobContext = createContext(null);